module.exports = __webpack_public_path__ + "static/media/settings_room_device_focus.db107ea9.svg";